import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { useAuth } from "./AuthContext";
import menuService from "../services/menuService";

const MenuContext = createContext(null);

export function MenuProvider({ children }) {
  const { user, isAuthenticated } = useAuth();
  const [visibleMenus, setVisibleMenus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [menusLoaded, setMenusLoaded] = useState(false);

  const loadMenus = useCallback(async () => {
    if (!isAuthenticated || !user) {
      setVisibleMenus([]);
      setMenusLoaded(false);
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      const menus = await menuService.getNavigationMenus();
      setVisibleMenus(menus);
      setMenusLoaded(true);
    } catch {
      setVisibleMenus([]);
      setMenusLoaded(true);
    } finally {
      setLoading(false);
    }
  }, [isAuthenticated, user]);

  useEffect(() => { loadMenus(); }, [loadMenus]);

  const refreshMenus = useCallback(() => loadMenus(), [loadMenus]);

  const isMenuVisible = (path) => {
    // While menus haven't loaded yet, ProtectedRoute's menuLoading spinner handles it
    if (!menusLoaded) return false;
    return visibleMenus.some(m => m.path === path);
  };

  return (
    <MenuContext.Provider value={{ visibleMenus, loading, menusLoaded, refreshMenus, isMenuVisible }}>
      {children}
    </MenuContext.Provider>
  );
}

export const useMenu = () => {
  const ctx = useContext(MenuContext);
  if (!ctx) throw new Error("useMenu must be used within MenuProvider");
  return ctx;
};
